import { storableError } from '../../util/errors';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { FirebaseApi } from '../../util/api';
import { StatusCode } from '../../util/enums';
import { showToaster } from '../../util/genericHelpers';
import { pick } from 'lodash';

// ================ Action types ================ //

export const FETCH_COST_ESTIMATION_DOCS_REQUEST =
  'app/CostEstimationDetailsPage/FETCH_COST_ESTIMATION_DOCS_REQUEST';
export const FETCH_COST_ESTIMATION_DOCS_SUCCESS =
  'app/CostEstimationDetailsPage/FETCH_COST_ESTIMATION_DOCS_SUCCESS';
export const FETCH_COST_ESTIMATION_DOCS_ERROR =
  'app/CostEstimationDetailsPage/FETCH_COST_ESTIMATION_DOCS_ERROR';

export const SET_INITIAL_VALUES = 'app/CostEstimationDetailsPage/SET_INITIAL_VALUES';

// ================ Reducer ================ //

const initialState = {
  costEstimationDocuments: [],
  fetchCostEstimationDocumentsError: null,
  fetchCostEstimationDocumentsInProgress: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };
    case FETCH_COST_ESTIMATION_DOCS_REQUEST:
      return {
        ...state,
        fetchCostEstimationDocumentsInProgress: true,
        fetchCostEstimationDocumentsError: null,
        costEstimationDocuments: [],
      };
    case FETCH_COST_ESTIMATION_DOCS_SUCCESS:
      return {
        ...state,
        costEstimationDocuments: payload,
        fetchCostEstimationDocumentsInProgress: false,
        fetchCostEstimationDocumentsError: null,
      };
    case FETCH_COST_ESTIMATION_DOCS_ERROR:
      return {
        ...state,
        fetchCostEstimationDocumentsInProgress: false,
        fetchCostEstimationDocumentsError: payload,
        costEstimationDocuments: [],
      };

    default:
      return state;
  }
}

// ================ Selectors ================ //

export const costEstimationDocumentsSelector = state =>
  state.CostEstimationDetailsPage.costEstimationDocuments;
export const fetchDocumentsInProgressSelector = state =>
  state.CostEstimationDetailsPage.fetchCostEstimationDocumentsInProgress;

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

export const fetchCostEstinmationDocsRequest = () => ({
  type: FETCH_COST_ESTIMATION_DOCS_REQUEST,
});
export const fetchCostEstinmationDocsSuccess = data => ({
  type: FETCH_COST_ESTIMATION_DOCS_SUCCESS,
  payload: data,
});
export const fetchCostEstinmationDocsError = e => ({
  type: FETCH_COST_ESTIMATION_DOCS_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

export const fetchCostEstimationDocuments = userId => async (dispatch, getState, sdk) => {
  dispatch(fetchCostEstinmationDocsRequest());
  try {
    const { statusCode, data } = await FirebaseApi.fetchCostEstimationsDocuments({ userId });
    if (statusCode === StatusCode.SUCCESS) {
      dispatch(fetchCostEstinmationDocsSuccess(data));
    }
  } catch (error) {
    const storable = storableError(error);
    dispatch(fetchCostEstinmationDocsError(storable));
    const errorMessage = error?.message || error?.toString() || 'Operation failed';
    showToaster('error', errorMessage);
    // Don't throw - error is already handled via toast and Redux state
    console.error('Failed to fetch cost estimation documents:', error);
  }
};

export const loadData = (params, search, config) => async dispatch => {
  dispatch(setInitialValues({ costEstimationDocuments: [] }));

  const currentUser = await dispatch(fetchCurrentUser());
  const currentUserId = currentUser?.id?.uuid;
  if (currentUserId) {
    dispatch(fetchCostEstimationDocuments(currentUserId));
  }
  return currentUser;
};
